module.exports = __webpack_public_path__ + "img/bg-top.8dc83eff.png";